<template>
  <flow-step-empty-base
    name="Cancellation Survey"
    :imgPath="img"
    description="Get insightful feedback from customers during the cancellation process."
    @cta-click="$emit('cta-click')"
  >
    <div>
      Responses to these questions are the core driver of Churnkey’s capabilities. Use these survey responses as a barometer of happiness across your
      customer base.
    </div>
  </flow-step-empty-base>
</template>

<script>
import FlowStepEmptyBase from '@/components/FlowSteps/FlowStepEmptyBase.vue';
import img from '@/assets/img/icon-survey.svg';

export default {
  name: 'FlowStepCancelSurveyEmpty',
  components: {
    FlowStepEmptyBase,
  },
  data() {
    return {
      img,
    };
  },
};
</script>
